import { ballArr, count, singleDouble, singleDoubleCnname, smallBig, continuity, continuityCnname, smallBigCnname, dragonTiger, fishCnname } from '../../../../helpers/resPatterns';
import dayjs from 'dayjs';

const ssc = (data, ballindex) => {
  let list = Vue => {
    let arr = [
      {
        title: '日期',
        align: 'center',
        className: `table_issueId`,
        width: 400,
        render: (h, { row }) => {
          return (
            <div>
              <span>{row.date}</span>
              <span>{` ${row.beginIssue} - ${row.endIssue} 期`}</span>
            </div>
          );
        }
      },
      {
        title: '单',
        align: 'center',
        className: `table_issueId`,
        render: (h, { row }) => {
          return (
            <div>
              <span>{row[ballindex]['single']}</span>
            </div>
          );
        }
      },
      {
        title: '双',
        align: 'center',
        className: `table_issueId`,
        render: (h, { row }) => {
          return (
            <div>
              <span>{row[ballindex]['double']}</span>
            </div>
          );
        }
      },
      {
        title: '大',
        align: 'center',
        className: `table_issueId`,
        render: (h, { row }) => {
          return (
            <div>
              <span>{row[ballindex]['big']}</span>
            </div>
          );
        }
      },
      {
        title: '小',
        align: 'center',
        className: `table_issueId`,
        render: (h, { row }) => {
          return (
            <div>
              <span>{row[ballindex]['small']}</span>
            </div>
          );
        }
      }
    ];
    // var a = ['一', '二', '三', '四', '五', '六', '七', '八', '九'];
    // for (let i = 0; i < data[0].ballList.length; i++) {
    //   let obj = {};
    //   let e = a[i];
    //   obj.title = `第${e}球`;
    //   obj.align = 'center';
    //   obj.width = '300';
    //   obj.key = 'resultStr';
    //   obj.className = `table_info_column_${i}`;
    //   obj.children = treeChildren(data, i);
    //   arr.push(obj);
    // }

    return arr;
  };

  return { list };
};

export default ssc;



// WEBPACK FOOTER //
// ./src/pages/Trend/Haomaguilvtongji/columns/ssc.js